
export default {
    name: 'coupon',
    components: {},
    props: {
        base_remise: Number,
        prix_apport_social: Number,
        prestations: Array,
        consultation_data: Object,
        toggle_coupon: Number
    },
    data() {
        return {
            is_remise: false,
            coupon_remise: '',
            coupon_pourcent: '',
            a_payer: '',

            remise: '',
            pourcentage: '',

            error_message: '',
            save_loading: false
        }
    },

    watch: {
        toggle_coupon() {
            this.is_remise = false,
            this.resetCalc()
        },

        remise() {
            this.calculateCouponPercent()
        },

        pourcentage() {
            this.calculateCouponRemise() 
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        toggleRemise() {
            this.is_remise = !this.is_remise
        },

        calculateCouponPercent() {
            this.error_message = ''
            const amount_is_empty = this.validateStringNotEmpty(this.remise)
            if (amount_is_empty) {
                this.resetCalc()
                return
            }
            this.remise = this.cleanNumber(this.remise)

            if (this.remise > this.base_remise) {
                this.coupon_pourcent = ''
                this.error_message = "La remise doit être inférieure au montant dû !"
                return
            }

            if (this.remise > 0) {
                this.coupon_remise = this.remise
                this.coupon_pourcent =  parseFloat((this.remise * 100) / this.base_remise).toFixed(2)
                this.a_payer = this.base_remise - this.coupon_remise
            }
        }, 

        calculateCouponRemise() {
            this.error_message = ''
            const amount_is_empty = this.validateStringNotEmpty(this.pourcentage)
            if (amount_is_empty) {
                this.resetCalc()
                return
            }
            this.pourcentage = this.cleanNumber(this.pourcentage)

            if (this.pourcentage > 100) {
                this.coupon_remise = ''
                this.error_message = "Le pourcentage doit être inférieur à 100% !"
                return
            }

            if (this.pourcentage >= 0 && this.pourcentage <= 100) {
                this.coupon_pourcent = this.pourcentage

                this.a_payer = 0
                this.coupon_remise = 0

                if (!this.isObjectEmpty(this.consultation_data)) {
                    let valeur_ajoutee = 0
                    if (this.consultation_data.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( this.consultation_data.taxe_specifique * (1 + (this.consultation_data.group_taxation.taux / 100)) ).toFixed(0)
                        valeur_ajoutee = parseInt(valeur_ajoutee)
                    }
                    // let prix_post_apport = this.consultation_data.prix_clinique - this.prix_apport_social
                    let prix_post_apport = this.consultation_data.prix_clinique

                    this.coupon_remise = parseInt((this.pourcentage * prix_post_apport) / 100)
                    this.a_payer = (Math.ceil( ((100 - this.coupon_pourcent) / 100) * prix_post_apport )) + valeur_ajoutee
                } else {
                    this.prestations.forEach(prestation => {
                        let valeur_ajoutee = 0
                        if (prestation.taxe_specifique > 0) {
                            valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.group_taxation.taux / 100)) ).toFixed(0)
                            valeur_ajoutee = parseInt(valeur_ajoutee)
                        }
                        this.coupon_remise += parseInt((this.pourcentage * prestation.prix_clinique) / 100) * prestation.qte
                        this.a_payer += (Math.ceil( ((100 - this.coupon_pourcent) / 100) * prestation.prix_clinique ) * prestation.qte) + valeur_ajoutee
                    });
                }
            }
        },

        resetCalc() {
            this.coupon_remise = ''
            this.coupon_pourcent = ''
            this.a_payer = ''
            this.remise = ''
            this.pourcentage = ''
        },

        handleCoupon() {
            this.error_message = ''
            const amount_is_empty = this.validateStringNotEmpty(this.a_payer)
            if (amount_is_empty) {
                this.error_message = "Merci de renseigner la remise ou le porcentage à appliquer pour le coupon de réduction !"
                return
            }
            this.save_loading = true

            this.a_payer = this.cleanNumber(this.a_payer)

            const data = {
                montant_du: this.a_payer,
                remise: this.coupon_remise,
                coupon_pourcent: this.coupon_pourcent
            }

            setTimeout(() => {
                this.save_loading = false
                this.$emit('emitCoupon', data)
                this.$refs.m_coupon.click()
            }, 500);
            

        }
    }
}